<section class="cd-stage" [class.cd-stage--urgent]="isUrgent" [class.cd-stage--due]="isDue">
  <div class="cd-sparkles" aria-hidden="true">
    <span></span><span></span><span></span><span></span><span></span><span></span>
  </div>
  <div class="cd-glow" aria-hidden="true"></div>

  <div class="cd-badge">{{ isDue ? 'Starting now' : 'Get ready' }}</div>
  <p class="cd-kicker">{{ isDue ? 'Almost time' : 'Live in' }}</p>
  <h2 class="cd-title">{{ webinarName || 'Your webinar' }}</h2>
  <p class="cd-sub" *ngIf="!isDue">Keep this page open. The review starts the moment this hits zero.</p>
  <p class="cd-sub" *ngIf="isDue">Doors are opening — hang tight.</p>

  <div class="cd-clock" role="timer" [attr.aria-label]="'Starts in ' + hours + ' hours ' + minutes + ' minutes ' + seconds + ' seconds'">
    <ng-container *ngIf="showHours">
      <div class="cd-unit">
        <span class="cd-num">{{ hours }}</span>
        <span class="cd-label">Hours</span>
      </div>
      <span class="cd-colon" aria-hidden="true">:</span>
    </ng-container>
    <div class="cd-unit">
      <span class="cd-num">{{ minutes }}</span>
      <span class="cd-label">Minutes</span>
    </div>
    <span class="cd-colon" aria-hidden="true">:</span>
    <div class="cd-unit cd-unit--seconds" [class.cd-unit--pulse]="secondPulse">
      <span class="cd-num">{{ seconds }}</span>
      <span class="cd-label">Seconds</span>
    </div>
  </div>

  <div class="cd-bar" aria-hidden="true">
    <div class="cd-bar-fill" [style.transform]="'scaleX(' + progress + ')'"></div>
  </div>
</section>
